import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import ICommonText from './ICommonText';
import { Table } from 'react-bootstrap';
import CommonTextListRow from './CommonTextListRow';

interface ICommonTextListProps {
    items: ICommonText[];
    delete: (id: number) => void;
}

const CommonTextList = (props: ICommonTextListProps) => {
    return (
        <Table responsive hover>
            <thead>
                <tr>
                    <th>{Translate('common-texts/list/header/name')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item: ICommonText) => {
                    return (
                        <CommonTextListRow CommonText={item} delete={props.delete} key={item.id} />
                    );
                })}
            </tbody>
        </Table>
    );
};

export default CommonTextList;
